module.exports = __webpack_public_path__ + "img/UTEAST-5.11bfc48f.jpg";